module.exports = __webpack_public_path__ + "img/Pritchard_map_2.e223ed45.jpg";